import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LanguageList, Translate } from '../../contexts/Language';
import { ErrorMessage } from '../Validator';


const LoginForm = props => {
  const { validation, onChange, formData, onLogin } = props;

  return (
    <div className="account-card-content">
      <ErrorMessage Validation={validation} />
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <form className="form-horizontal m-t-30" name="loginForm" onSubmit={e => { e.preventDefault(); onLogin(formData); }}>
        <div className="form-group">
          <label htmlFor="username">{Translate('User Id')}</label>
          <input type="email" className="form-control" id="AccountLogin" name="AccountLogin" placeholder={Translate('Enter user id')} onChange={e => onChange(e)} required />
        </div>

        <div className="form-group">
          <label htmlFor="userpassword">{Translate('Password')}</label>
          <input type="password" className="form-control" id="Password" name="Password" placeholder={Translate('Enter password')} onChange={e => onChange(e)} required />
        </div>

        <div className="form-group row m-t-20">
          <div className="col-sm-6">
            <LanguageList />
          </div>
          <div className="col-sm-6 text-right">
            <button type="submit" className="btn btn-info w-md waves-effect waves-light">{Translate('Log In')}</button>
          </div>
        </div>
        <div className="form-group m-t-10 mb-0 row">
          <div className="col-12 m-t-20">
            <Link to="/recoverpassword">
              <i className="mdi mdi-lock mr-2" />
              <span>Forgot your password?</span>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

LoginForm.propTypes = {
  validation: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  onLogin: PropTypes.func.isRequired,
};

export default LoginForm;
